// extracted by mini-css-extract-plugin
export default {"component":"Read_component__0TJVd","small":"Read_small__27hkm","block":"Read_block__vkHw9"};